import { render } from "./ZaloChatHelper.vue?vue&type=template&id=0ff010f9&scoped=true"
import script from "./ZaloChatHelper.vue?vue&type=script&lang=js"
export * from "./ZaloChatHelper.vue?vue&type=script&lang=js"

import "./ZaloChatHelper.vue?vue&type=style&index=0&id=0ff010f9&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ff010f9"]])

export default __exports__